// src/pages/ForCreators/ForCreators.js
import React from 'react';
import { handleLoginRedirect } from '../../utils/locationUtils';
import CreatorHero from '../../components/ForCreator/CreatorHero/CreatorHero';
import VerticalInfoContainer from '../../components/ForCreator/VerticalInfoContainer/VerticalInfoContainer';
import MessageBox from '../../components/ForCreator/MessageBox/MessageBox';
import PurposeSection from '../../components/PurposeSection/PurposeSection';
import './ForCreators.css';

const ForCreators = () => {
  const handleLoginClick = () => {
    handleLoginRedirect();
  };

  return (
    <div className="for-creators-page">
      {/* Hero section */}
      <section className="hero-section">
        <div className="container">
          <CreatorHero onButtonClick={handleLoginClick} />
        </div>
      </section>

      {/* Info container section */}
      {/* <section className="info-section">
        <div className="container">
          <InfoContainer />
        </div>
      </section> */}

      {/* Vertical info container section */}
      <section className="vertical-info-section">
        <div className="container">
          <VerticalInfoContainer />
        </div>
      </section>

      {/* Message box section */}
      <section className="message-section">
        <div className="container">
          <MessageBox />
        </div>
      </section>

      {/* Purpose section */}
      <section className="purpose-section">
        <div className="container">
          <PurposeSection />
        </div>
      </section>
    </div>
  );
};

export default ForCreators;
